(function(){
'use strict';
var G = window.Glowcea = window.Glowcea || {};
var cfg = window.GlowceaConfig || {};
var $ = function(s,c){return (c||document).querySelector(s)};
var $$ = function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
G.money = function(cents){
var fmt = cfg.moneyFormat || '${{amount}}';
cents = parseInt(cents||0,10);
function d(n,p,t,s){ t=t||','; s=s||'.'; var v=(n/100).toFixed(p); var parts=v.split('.'); return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1'+t)+(parts[1]?s+parts[1]:''); }
return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(_,k){
switch(k){
case 'amount_no_decimals': return d(cents,0);
case 'amount_with_comma_separator': return d(cents,2,'.',',');
case 'amount_no_decimals_with_comma_separator': return d(cents,0,'.',',');
default: return d(cents,2);
}
});
};
function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
function img(url,w){ if(!url) return ''; try{ var u=new URL(url, location.origin); u.searchParams.set('width', w||300); return u.toString(); }catch(e){ return url; } }
function initReveal(root){
var els = $$('.g-reveal:not(.is-in)', root);
if(!('IntersectionObserver' in window) || reduce){ els.forEach(function(e){e.classList.add('is-in')}); return; }
var io = new IntersectionObserver(function(entries){
entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
},{rootMargin:'0px 0px -8% 0px',threshold:.08});
els.forEach(function(e){io.observe(e)});
}
function initAnnounce(root){
$$('[data-g-announce]', root).forEach(function(el){
if(el._g) return; el._g=1;
var items = $$('.g-announce__item', el); if(items.length<2) return;
var i=0, timer, speed=(parseInt(el.dataset.speed,10)||5)*1000;
function go(n){
var cur=items[i]; cur.classList.remove('is-active'); cur.classList.add('is-leaving');
setTimeout(function(){cur.classList.remove('is-leaving')},600);
i=(n+items.length)%items.length; items[i].classList.add('is-active');
}
function play(){ clearInterval(timer); if(!reduce) timer=setInterval(function(){go(i+1)},speed); }
var p=$('[data-prev]',el), n=$('[data-next]',el);
p&&p.addEventListener('click',function(){go(i-1);play()});
n&&n.addEventListener('click',function(){go(i+1);play()});
el.addEventListener('mouseenter',function(){clearInterval(timer)});
el.addEventListener('mouseleave',play);
play();
});
}
var lastFocus;
G.openDrawer = function(id){
var d=document.getElementById(id); if(!d) return;
lastFocus=document.activeElement;
d.classList.add('is-open'); d.setAttribute('aria-hidden','false');
document.documentElement.style.overflow='hidden';
var f=$('button, a, input',d.querySelector('.g-drawer__panel')); f&&setTimeout(function(){f.focus()},50);
};
G.closeDrawer = function(d){
if(typeof d==='string') d=document.getElementById(d);
if(!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden','true');
if(!$('.g-drawer.is-open')) document.documentElement.style.overflow='';
lastFocus&&lastFocus.focus&&lastFocus.focus();
};
document.addEventListener('click',function(e){
var o=e.target.closest('[data-g-open]'); if(o){ e.preventDefault(); if(o.dataset.gOpen==='g-cart'){G.cart.refresh();} G.openDrawer(o.dataset.gOpen); return; }
var c=e.target.closest('[data-g-close]'); if(c){ e.preventDefault(); G.closeDrawer(c.closest('.g-drawer')); }
});
document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ $$('.g-drawer.is-open').forEach(G.closeDrawer); } });
function initHeader(root){
var h=$('[data-g-header]',root); if(!h||h._g) return; h._g=1;
var onScroll=function(){ h.classList.toggle('is-scrolled', window.scrollY>10); };
window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
var st=$('[data-g-search-toggle]',h), sb=$('.g-header__search',h);
st&&st.addEventListener('click',function(){ sb.classList.toggle('is-open'); var i=$('input',sb); if(sb.classList.contains('is-open')&&i) i.focus(); st.setAttribute('aria-expanded', sb.classList.contains('is-open')); });
}
G.toast=function(msg){
var t=$('.g-toast'); if(!t){ t=document.createElement('div'); t.className='g-toast g-scope'; t.setAttribute('role','status'); document.body.appendChild(t); }
t.textContent=msg; t.classList.add('is-visible'); clearTimeout(t._t); t._t=setTimeout(function(){t.classList.remove('is-visible')},2600);
};
G.cart = {
root:function(){ return document.getElementById('g-cart'); },
fetch:function(url,opts){ return fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+url.replace(/^\//,''),Object.assign({headers:{'Content-Type':'application/json','Accept':'application/json'}},opts||{})).then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); }); },
add:function(items){
var self=this, r=this.root(); r&&r.classList.add('is-loading');
return this.fetch('cart/add.js',{method:'POST',body:JSON.stringify({items:items})})
.then(function(){ return self.refresh(); })
.then(function(){ if(self.root()) G.openDrawer('g-cart'); else window.location.href=(window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart'; })
.catch(function(err){ G.toast((err&&(err.description||err.message))||'Something went wrong. Please try again.'); })
.finally(function(){ r&&r.classList.remove('is-loading'); });
},
change:function(key,qty){
var self=this, r=this.root(); r&&r.classList.add('is-loading');
return this.fetch('cart/change.js',{method:'POST',body:JSON.stringify({id:key,quantity:qty})})
.then(function(c){ self.render(c); })
.catch(function(err){ G.toast((err&&err.description)||'Could not update your bag.'); self.refresh(); })
.finally(function(){ r&&r.classList.remove('is-loading'); });
},
refresh:function(){ var self=this; return this.fetch('cart.js').then(function(c){ self.render(c); return c; }).catch(function(){}); },
render:function(c){
$$('[data-g-cart-count]').forEach(function(el){ var old=el.dataset.count; el.textContent=c.item_count; el.dataset.count=c.item_count; if(String(old)!==String(c.item_count)){ el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); } });
var r=this.root(); if(!r) return;
var list=$('[data-g-cart-items]',r), empty=$('[data-g-cart-empty]',r), foot=$('[data-g-cart-foot]',r);
$('[data-g-cart-title-count]',r)&&($('[data-g-cart-title-count]',r).textContent=c.item_count?'('+c.item_count+')':'');
if(!c.item_count){ list.innerHTML=''; empty.hidden=false; foot.hidden=true; }
else{
empty.hidden=true; foot.hidden=false;
list.innerHTML=c.items.map(function(it){
var variant = (it.variant_title && it.variant_title!=='Default Title') ? '<div class="g-cart__variant">'+esc(it.variant_title)+'</div>' : '';
var plan = it.selling_plan_allocation ? '<div class="g-cart__variant">'+esc(it.selling_plan_allocation.selling_plan.name)+'</div>' : '';
var price = it.original_line_price!==it.final_line_price ? '<s>'+G.money(it.original_line_price)+'</s> '+G.money(it.final_line_price) : G.money(it.final_line_price);
return '<li class="g-cart__item">'+
'<a class="g-cart__img" href="'+esc(it.url)+'">'+(it.image?'<img src="'+esc(img(it.image,200))+'" alt="'+esc(it.product_title)+'" width="84" height="84" loading="lazy">':'')+'</a>'+
'<div><a class="g-cart__name" href="'+esc(it.url)+'">'+esc(it.product_title)+'</a>'+variant+plan+
'<div class="g-cart__row"><div class="g-qty" role="group" aria-label="Quantity">'+
'<button type="button" data-g-line-qty="'+esc(it.key)+'" data-q="'+(it.quantity-1)+'" aria-label="Decrease quantity">−</button>'+
'<input type="number" min="0" value="'+it.quantity+'" data-g-line-input="'+esc(it.key)+'" aria-label="Quantity for '+esc(it.product_title)+'">'+
'<button type="button" data-g-line-qty="'+esc(it.key)+'" data-q="'+(it.quantity+1)+'" aria-label="Increase quantity">+</button>'+
'</div><strong style="font-size:.92rem">'+price+'</strong></div>'+
'<button type="button" class="g-cart__remove" data-g-line-qty="'+esc(it.key)+'" data-q="0">Remove</button></div></li>';
}).join('');
}
var sub=$('[data-g-cart-subtotal]',r); sub&&(sub.textContent=G.money(c.total_price));
var fs=$('[data-g-free]',r);
if(fs){
var th=parseFloat(fs.dataset.threshold||0)*100*(window.Shopify&&Shopify.currency&&Shopify.currency.rate?parseFloat(Shopify.currency.rate):1);
if(th>0 && c.item_count){
fs.hidden=false; var left=th-c.total_price;
$('[data-g-free-text]',fs).innerHTML = left>0 ? (fs.dataset.msg||'You are [amount] away from free shipping').replace('[amount]','<strong>'+G.money(left)+'</strong>') : (fs.dataset.done||'You unlocked free shipping!');
$('span',$('.g-cart__bar',fs)).style.width=Math.min(100,c.total_price/th*100)+'%';
} else fs.hidden=true;
}
var inCart=c.items.map(function(i){return i.product_id});
$$('[data-g-upsell-item]',r).forEach(function(u){ u.hidden = inCart.indexOf(parseInt(u.dataset.productId,10))>-1; });
var up=$('[data-g-upsell]',r); if(up){ up.hidden = !$$('[data-g-upsell-item]:not([hidden])',r).length; }
}
};
document.addEventListener('click',function(e){
var q=e.target.closest('[data-g-line-qty]'); if(q){ e.preventDefault(); G.cart.change(q.dataset.gLineQty, Math.max(0,parseInt(q.dataset.q,10))); return; }
var a=e.target.closest('[data-g-quick-add]'); if(a){ e.preventDefault(); a.disabled=true; var t=a.innerHTML; a.textContent=a.dataset.adding||'Adding…'; G.cart.add([{id:parseInt(a.dataset.gQuickAdd,10),quantity:1}]).finally(function(){a.disabled=false;a.innerHTML=t;}); }
});
document.addEventListener('change',function(e){
var i=e.target.closest('[data-g-line-input]'); if(i){ G.cart.change(i.dataset.gLineInput, Math.max(0,parseInt(i.value,10)||0)); }
});
document.addEventListener('submit',function(e){
var f=e.target.closest('form[data-g-atc]'); if(!f) return;
if(!G.cart.root()) return; // fall back to native submit (/cart/add)
e.preventDefault();
var fd=new FormData(f), item={id:parseInt(fd.get('id'),10),quantity:parseInt(fd.get('quantity')||1,10)};
if(fd.get('selling_plan')) item.selling_plan=parseInt(fd.get('selling_plan'),10);
var btns=$$('[type="submit"]',f).concat($$('[data-g-sticky-submit]'));
btns.forEach(function(b){b.disabled=true; b.setAttribute('aria-busy','true');});
G.cart.add([item]).finally(function(){ btns.forEach(function(b){ b.removeAttribute('aria-busy'); if(!b.hasAttribute('data-g-unavail')) b.disabled=false; }); });
});
document.addEventListener('click',function(e){
var b=e.target.closest('[data-g-step]'); if(!b) return;
var input=b.parentNode.querySelector('input'); var v=(parseInt(input.value,10)||1)+parseInt(b.dataset.gStep,10);
input.value=Math.max(parseInt(input.min||1,10),v); input.dispatchEvent(new Event('change',{bubbles:true}));
});
function initHero(root){
$$('[data-g-hero]',root).forEach(function(h){
if(h._g) return; h._g=1;
var slides=$$('.g-hero__slide',h), dots=$$('.g-hero__dot',h); if(slides.length<2) return;
var i=0, timer, speed=(parseInt(h.dataset.speed,10)||6)*1000, auto=h.dataset.autoplay==='true';
function go(n){ slides[i].classList.remove('is-active'); slides[i].setAttribute('aria-hidden','true'); dots[i]&&dots[i].classList.remove('is-active'); dots[i]&&dots[i].setAttribute('aria-current','false');
i=(n+slides.length)%slides.length; slides[i].classList.add('is-active'); slides[i].setAttribute('aria-hidden','false'); dots[i]&&dots[i].classList.add('is-active'); dots[i]&&dots[i].setAttribute('aria-current','true'); }
function play(){ clearInterval(timer); if(auto&&!reduce) timer=setInterval(function(){go(i+1)},speed); }
dots.forEach(function(d,k){ d.addEventListener('click',function(){go(k);play()}); });
var p=$('[data-prev]',h), n=$('[data-next]',h);
p&&p.addEventListener('click',function(){go(i-1);play()}); n&&n.addEventListener('click',function(){go(i+1);play()});
h.addEventListener('mouseenter',function(){clearInterval(timer)}); h.addEventListener('mouseleave',play);
h.addEventListener('focusin',function(){clearInterval(timer)});
var x0=null; h.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
h.addEventListener('touchend',function(e){ if(x0===null) return; var dx=e.changedTouches[0].clientX-x0; if(Math.abs(dx)>45){ go(dx<0?i+1:i-1); play(); } x0=null; });
document.addEventListener('shopify:block:select',function(e){ var k=slides.indexOf(e.target); if(k>-1){ clearInterval(timer); go(k); } });
play();
});
}
function initRails(root){
$$('[data-g-rail-wrap]',root).forEach(function(w){
if(w._g) return; w._g=1;
var rail=$('.g-rail',w), prev=$('[data-rail-prev]',w), next=$('[data-rail-next]',w); if(!rail) return;
function upd(){ if(!prev) return; prev.disabled=rail.scrollLeft<=4; next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-4; }
function step(dir){ var c=rail.firstElementChild; var s=c?c.getBoundingClientRect().width+parseFloat(getComputedStyle(rail).columnGap||20):rail.clientWidth*.8; rail.scrollBy({left:dir*s,behavior:reduce?'auto':'smooth'}); }
prev&&prev.addEventListener('click',function(){step(-1)}); next&&next.addEventListener('click',function(){step(1)});
rail.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd); setTimeout(upd,100);
});
}
function initTabs(root){
$$('[data-g-tabs]',root).forEach(function(t){
if(t._g) return; t._g=1;
var tabs=$$('[role="tab"]',t);
function sel(tab){
tabs.forEach(function(x){ var on=x===tab; x.setAttribute('aria-selected',on); x.tabIndex=on?0:-1; var p=document.getElementById(x.getAttribute('aria-controls')); if(p){ p.hidden=!on; if(on){ p.classList.remove('is-in'); void p.offsetWidth; p.classList.add('is-in'); if(p.hasAttribute('data-g-recent')) G.recent.render(p); } } });
}
tabs.forEach(function(x,k){
x.addEventListener('click',function(){sel(x)});
x.addEventListener('keydown',function(e){ var n=null; if(e.key==='ArrowRight') n=tabs[(k+1)%tabs.length]; if(e.key==='ArrowLeft') n=tabs[(k-1+tabs.length)%tabs.length]; if(n){ e.preventDefault(); n.focus(); sel(n);} });
});
});
}
G.recent = {
key:'glowcea:recent',
get:function(){ try{ return JSON.parse(localStorage.getItem(this.key)||'[]'); }catch(e){ return []; } },
push:function(handle){ if(!handle) return; try{ var a=this.get().filter(function(h){return h!==handle}); a.unshift(handle); localStorage.setItem(this.key,JSON.stringify(a.slice(0,10))); }catch(e){} },
render:function(el){
if(el._rendered) return; el._rendered=true;
var exclude=el.dataset.exclude, list=this.get().filter(function(h){return h!==exclude}).slice(0,parseInt(el.dataset.limit||8,10));
var target=$('[data-g-recent-list]',el)||el, empty=$('[data-g-recent-empty]',el), section=el.closest('[data-g-recent-section]');
if(!list.length){ if(empty) empty.hidden=false; if(section) section.hidden=true; return; }
Promise.all(list.map(function(h){ return fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'products/'+encodeURIComponent(h)+'.js').then(function(r){return r.ok?r.json():null}).catch(function(){return null}); }))
.then(function(ps){
ps=ps.filter(Boolean); if(!ps.length){ if(empty) empty.hidden=false; if(section) section.hidden=true; return; }
if(section) section.hidden=false;
var atc=el.dataset.atc||'Add to bag', sold=el.dataset.soldout||'Sold out';
target.innerHTML=ps.map(function(p){
var v=(p.variants||[]).filter(function(x){return x.available})[0]||p.variants[0];
var btn = p.variants.length>1 ? '<a class="g-btn g-btn--outline g-btn--sm g-btn--block g-card__atc" href="'+esc(p.url)+'">'+esc(el.dataset.choose||'Choose options')+'</a>'
: (v&&v.available ? '<button type="button" class="g-btn g-btn--outline g-btn--sm g-btn--block g-card__atc" data-g-quick-add="'+v.id+'">'+esc(atc)+'</button>' : '<button type="button" class="g-btn g-btn--outline g-btn--sm g-btn--block g-card__atc" disabled>'+esc(sold)+'</button>');
return '<div class="g-card">'+
'<a class="g-card__media" href="'+esc(p.url)+'" tabindex="-1" aria-hidden="true">'+(p.featured_image?'<img src="'+esc(img(p.featured_image,600))+'" alt="" loading="lazy" width="600" height="600">':'')+'</a>'+
'<div class="g-card__body"><h3 class="g-card__title"><a href="'+esc(p.url)+'">'+esc(p.title)+'</a></h3>'+
'<div class="g-card__price">'+G.money(p.price)+(p.compare_at_price>p.price?'<s>'+G.money(p.compare_at_price)+'</s>':'')+'</div>'+btn+'</div></div>';
}).join('');
initRails(el.closest('section')||document);
});
}
};
function initProduct(root){
$$('[data-g-product]',root).forEach(function(p){
if(p._g) return; p._g=1;
G.recent.push(p.dataset.handle);
var jsonEl=$('[data-g-product-json]',p), data=jsonEl?JSON.parse(jsonEl.textContent):null;
var form=$('form[data-g-atc]',p), idInput=form&&$('input[name="id"]',form);
var btn=form&&$('[data-g-atc-btn]',form), sticky=document.querySelector('[data-g-sticky]');
var slidesWrap=$('.g-gallery__slides',p), slides=$$('.g-gallery__slide',p), thumbs=$$('.g-gallery__thumb',p), dots=$$('.g-gallery__dots button',p);
function mark(k){ thumbs.forEach(function(t,j){t.setAttribute('aria-current',j===k)}); dots.forEach(function(t,j){t.setAttribute('aria-current',j===k)}); }
function goTo(k){ if(!slides[k]) return; slidesWrap.scrollTo({left:slides[k].offsetLeft,behavior:reduce?'auto':'smooth'}); mark(k); }
thumbs.forEach(function(t,k){ t.addEventListener('click',function(){goTo(k)}); });
dots.forEach(function(t,k){ t.addEventListener('click',function(){goTo(k)}); });
if(slidesWrap){ var st; slidesWrap.addEventListener('scroll',function(){ clearTimeout(st); st=setTimeout(function(){ var k=Math.round(slidesWrap.scrollLeft/slidesWrap.clientWidth); mark(k); },60); },{passive:true}); }
var prev=$('[data-gal-prev]',p), next=$('[data-gal-next]',p);
slides.forEach(function(s){
s.addEventListener('click',function(e){ if(window.matchMedia('(hover:none)').matches) return; s.classList.toggle('is-zoom'); });
s.addEventListener('mousemove',function(e){ if(!s.classList.contains('is-zoom')) return; var r=s.getBoundingClientRect(), im=$('img',s); if(im) im.style.transformOrigin=((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%'; });
s.addEventListener('mouseleave',function(){ s.classList.remove('is-zoom'); });
});
$$('input[name="g-purchase"]',p).forEach(function(r){
r.addEventListener('change',function(){
var sp=$('input[name="selling_plan"]',form); if(sp) sp.value = r.value==='once' ? '' : r.value;
updatePrice();
});
});
function currentVariant(){
if(!data) return null;
if(data.variants.length===1) return data.variants[0];
var opts=$$('fieldset[data-g-option]',p).map(function(fs){ var c=$('input:checked',fs); return c?c.value:null; });
return data.variants.filter(function(v){ return v.options.every(function(o,k){return o===opts[k]}); })[0]||null;
}
function updatePrice(){
var v=currentVariant(); if(!v) return;
var pr=$('[data-g-price]',p), cmp=$('[data-g-compare]',p);
var sel=$('input[name="g-purchase"]:checked',p), price=v.price;
if(sel&&sel.value!=='once'&&v.selling_plan_allocations){ var a=v.selling_plan_allocations.filter(function(x){return String(x.selling_plan_id)===sel.value})[0]; if(a) price=a.price; }
if(pr) pr.textContent=G.money(price);
$$('[data-g-btn-price]',p).forEach(function(e){e.textContent=G.money(price)});
if(cmp){ if(v.compare_at_price>price){ cmp.hidden=false; cmp.textContent=G.money(v.compare_at_price);} else cmp.hidden=true; }
$$('[data-g-sticky-price]').forEach(function(e){e.textContent=G.money(price)});
}
$$('fieldset[data-g-option] input',p).forEach(function(i){
i.addEventListener('change',function(){
var v=currentVariant(); var legendVal=$('[data-g-option-value]',i.closest('fieldset')); legendVal&&(legendVal.textContent=i.value);
var all=[btn].concat($$('[data-g-sticky-submit]')).filter(Boolean);
if(!v){ all.forEach(function(b){ b.disabled=true; b.setAttribute('data-g-unavail',''); b.textContent=btn.dataset.unavailable; }); return; }
idInput.value=v.id;
all.forEach(function(b){
b.disabled=!v.available; b.toggleAttribute('data-g-unavail',!v.available);
if(!v.available) b.textContent=b.dataset.soldout;
else b.innerHTML = b===btn ? esc(b.dataset.add)+' — <span data-g-btn-price></span>' : esc(b.dataset.add);
});
updatePrice();
if(v.featured_media){ var k=slides.map(function(s){return s.dataset.mediaId}).indexOf(String(v.featured_media.id)); if(k>-1) goTo(k); }
if(history.replaceState){ var u=new URL(location.href); u.searchParams.set('variant',v.id); history.replaceState({},'',u); }
});
});
if(sticky&&btn&&'IntersectionObserver' in window){
var io=new IntersectionObserver(function(en){ var e=en[0]; var past=!e.isIntersecting && e.boundingClientRect.top<0; sticky.classList.toggle('is-visible',past); sticky.setAttribute('aria-hidden',!past); },{threshold:0});
io.observe(btn);
$$('[data-g-sticky-submit]',sticky).forEach(function(b){ b.addEventListener('click',function(){ if(form.requestSubmit) form.requestSubmit(); else btn.click(); }); });
}
});
}
document.addEventListener('click',function(e){
var b=e.target.closest('[data-g-more]'); if(!b) return;
var s=b.closest('.g-seo'); s.classList.toggle('is-open'); var o=s.classList.contains('is-open');
b.textContent=o?b.dataset.less:b.dataset.more; b.setAttribute('aria-expanded',o);
});
function init(root){
root=root||document;
initReveal(root); initAnnounce(root); initHeader(root); initHero(root); initRails(root); initTabs(root); initProduct(root);
$$('[data-g-recent]:not([hidden])',root).forEach(function(el){ G.recent.render(el); });
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){init()}); else init();
document.addEventListener('shopify:section:load',function(e){ init(e.target); });
})();